import React from "react";
import PropTypes from "prop-types";
import { Box, Button, Typography } from "@mui/material";
import { BCPCheck, BCPXmark } from "../../../components/icons/bcp/BCPIcons";

const SubscriptionCard = ({
  title,
  forWho,
  price,
  currency,
  interval,
  benefits,
  buttonText,
  buttonLink,
  isDisabled,
  savingsAmount
}) => {
  return (
    <Box
      sx={{
        display: "inline-block",
        margin: { xs: "5px 0", sm: "10px 1%" },
        fontFamily: "'Lato', Arial, sans-serif",
        width: "100%",
        height: "100%",
        marginBottom: "24px",
      }}
    >
      <Box
        sx={{
          background: "#1E1E1E",
          margin: "0 auto",
          width: "100%",
          height: "100%",
          maxWidth: "100%",
          position: "relative",
          border: "1px solid rgba(255, 255, 255, 0.12)",
          borderRadius: 1,
          boxShadow: 1,
          color: "white",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {savingsAmount && (
          <Box
            sx={{
              position: "absolute",
              top: "-11px",
              right: "16px",
              backgroundColor: "#4CAF50",
              color: "white",
              padding: "6px 16px",
              borderRadius: "16px",
              fontSize: "0.8rem",
              fontWeight: 650,
              zIndex: 1,
              boxShadow: "0 2px 5px rgba(0,0,0,0.22)"
            }}
          >
            Save ${savingsAmount}!
          </Box>
        )}
        <Box
          sx={{
            textAlign: "center",
            padding: { xs: "1.5rem", sm: "2rem" },
            display: "flex",
            flexDirection: "column",
            height: "100%",
            justifyContent: "space-between",
          }}
        >
          <Box>
            {/* Remove Subscsription names for now - leaving title props in incase we want to update later */}
            {/* <Typography
              variant="h3"
              sx={{
                color: "#B8B5CB",
                fontSize: { xs: "1.75rem", sm: "2rem" },
                fontWeight: 700,
                mb: 1,
              }}
            >
              {title}
            </Typography> */}

            <Typography
              variant="subtitle1"
              sx={{
                color: "#B8B5CB",
                fontSize: { xs: "1.25rem", sm: "1.5rem" },
                fontWeight: 600,
                mb: 1,
              }}
            >
              {forWho}
            </Typography>

            <Box sx={{ position: "relative", display: "inline-block", mb: 1 }}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { xs: "2.5rem", sm: "3rem" },
                  fontWeight: 700,
                  color: "white",
                }}
              >
                {price === 0
                  ? "FREE"
                  : `${currency === "ZAR" ? "R" : "$"}${price}`}
              </Typography>
            </Box>

            <Typography
              variant="subtitle2"
              sx={{
                color: "rgba(255, 255, 255, 0.7)",
                mb: 4,
                minHeight: "24px",
              }}
            >
              {price === 0 ? "" : interval}
            </Typography>

            <Box
              sx={{
                mb: { xs: 3, sm: 4 },
                mt: { xs: 2, sm: 3 },
                minHeight: "100px",
              }}
            >
              {benefits.map((benefit, index) => (
                <Box
                  key={index}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    mb: { xs: 0.75, sm: 1 },
                    px: { xs: 1, sm: 0 },
                    color: benefit.isAvailable
                      ? "white"
                      : "rgba(255, 255, 255, 0.5)",
                  }}
                >
                  {benefit.isAvailable ? (
                    <BCPCheck color="success" />
                  ) : (
                    <BCPXmark sx={{ color: "#ff4444" }} />
                  )}
                  <Typography>{benefit.text}</Typography>
                </Box>
              ))}
            </Box>
          </Box>

          <Button
            variant="contained"
            href={buttonLink}
            disabled={isDisabled}
            fullWidth
            sx={{
              py: { xs: 1.25, sm: 1.5 },
              fontWeight: 600,
              backgroundColor: isDisabled ? "grey.500" : "#6B5ECD",
              "&:hover": {
                backgroundColor: isDisabled ? "grey.500" : "#5648B2",
              },
              fontSize: { xs: "0.9rem", sm: "1rem" },
              mt: "auto",
            }}
          >
            {buttonText}
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

SubscriptionCard.propTypes = {
  title: PropTypes.string.isRequired,
  forWho: PropTypes.string.isRequired,
  price: PropTypes.number.isRequired,
  currency: PropTypes.string.isRequired,
  interval: PropTypes.string.isRequired,
  benefits: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string.isRequired,
      isAvailable: PropTypes.bool.isRequired,
    })
  ).isRequired,
  buttonText: PropTypes.string.isRequired,
  buttonLink: PropTypes.string.isRequired,
  isPromoted: PropTypes.bool,
  isDisabled: PropTypes.bool,
  savingsAmount: PropTypes.number
};

export default SubscriptionCard;
